import {
    CircularProgress, ExpansionPanel, ExpansionPanelDetails, 
    ExpansionPanelSummary, 
    FormControl, Input, Icon, MenuItem, Select, Snackbar,
    Step, StepLabel, Stepper, TextField, Typography,Grid
} from "@material-ui/core";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Autocomplete from "@material-ui/lab/Autocomplete";
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import _, { cloneDeep } from "lodash";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptLocale from "date-fns/locale/pt";
import buildQuery from "odata-query";
import React, { useLayoutEffect, useState, useEffect } from 'react';
import { Badge, Button, Modal, Popover, OverlayTrigger } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { object } from 'yup';
import { getStructureTree, getUser, getUserFactoryId } from '../../../index';
import AlertHelper from '../../components/Alert';
import { GalleryLightbox } from '../../components/Gallery';
import { Loading } from '../../components/Loading/Loading';
import { ExternalStandardModal } from '../../components/StandardView/Modal/ExternalStandardModal';
import { isEmptyArray } from '../../helpers/array';
import { getUserAccessLevel } from "../../helpers/role";
import { parse, recursiveGetMachinesByKey, recursiveGetLineParentByKey } from '../../helpers/three';
import { getMyApprovalsAPI } from '../../pages/ApprovalFlow/_redux/ApprovalCrud';
import api from '../../services/api';
import { fetchTrainingSimple } from '../Lpp/_redux/lppsCrud';
import { createFunnel, fetchDataView, updateFunnel } from './_redux/FunnelCrud';
import dataURLtoBlob from 'blueimp-canvas-to-blob'
import SignatureCanvas from 'react-signature-canvas';
import makeAnimated from 'react-select/animated';
import { SelectAsyncPaginateUsers } from '../../components/Select/';

import { Tooltip, withStyles } from '@material-ui/core';

import TemplateFunilActivities from '../../../assets/templates/Template_Importar_Atividades.xlsx'

let step = 1
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 15,
        whiteSpace: 'pre-line'
    },
}))(Tooltip);

export function FunnelEdit(props) {
    const animatedComponents = makeAnimated();
    const [isSaving, setIsSaving] = useState(false);
    const baseActivity = {
        "activity": "",
        "classification": "",
        "createdAt": new Date(),        
        "question1": false,
        "question2": false,
        "question3": false,
        "question4": false,
        "question5": false,
        "question6": false,
        "question7": false,
        "question8": false,
        "question9": false,
        "question10": false,
        "transfer": false,
        "inspection": false,
        "repair": false,
        "gtmApproval": false,
        "signaturegtmApproval": '',
        "gtaApproval": false,
        "signaturegtaApproval": '',
        "lppTrained": null,
        "dtpTrained": null,
        "lppId": null,
        "dtpId": null,
        "managerGTMApproval": null,
        "managerGTMApprovalUserId": null,
        "managerGTAApproval": null,
        "managerGTAApprovalUserId": null,
        "sheApproval": null,
        "sheApprovalUserId": null,
        "type": "",
        "smallRepair": false       
    };

    const [funnel, setFunnel] = useState({        
        "gtmUserId": 0,
        "gtaUserId": 0,
        "structureId": 0,
        "status": 1
    });
    const [funnelActivity, setFunnelActivity] = useState([baseActivity]);
    const [redirect, setRedirect] = useState('');
    const [machine, setMachine] = useState([]);
    const [usersToUse, setUsersToUse] = useState([]);
    const [treeData, setTreeData] = useState([]);
    const [setores, setSetores] = useState([]);
    const [load, setLoad] = useState(false)
    const [funilEditor, setFunilEditor] = useState(false);
    const [sheApprover, setSHEApprover] = useState(false);
    const [gtmApprover, setGTMApprover] = useState(false);
    const [gtaApprover, setGTAApprover] = useState(false);
    const [filterActivityName, setFilterActivityName] = useState('');
    const [filterType, setFilterType] = useState('Todos');
    const [snackBar, setSnackBar] = useState({
        isOpen: false,
        message: '',
        vertical: 'top',
        horizontal: 'right',
        type: 'error'
    });

    const [activeStep, setActiveStep] = useState(0);
    const steps = ['Funil', 'Pequeno Reparo', 'Fluxo Aprovação', 'PLIL', 'Documentos', 'Transferência', 'Aprovação'];
    const [modal, setModal] = useState(false);
    const [modalDisapproval, setModalDisapproval] = useState(false);
    const [showModalDoc, setModalDoc] = useState(false);
    const [modalValidate, setModalValidate] = useState(false);
    const [options, setOptions] = useState([]);
    const [activityQtd, setActivityQtd] = useState(0);
    const [isAdmin, setIsAdmin] = useState(getUserAccessLevel() > 1);
    const [activityCheckingTraining, setActivityCheckingTraining] = useState(0);
    const [originalArrayActivities, setOriginalArrayActivities] = useState([])
    const [toIncludeArray, setToIncludeArray] = useState([])
    const [searchAt, setSearchAt] = useState('');
    const [modalEditActivityName, setModalEditActivityName] = useState(false)
    const [name, setName] = useState('')
    const [copy_activity, setCopy_activity] = useState([])
    const [filterState, setFiltersState ] = useState({
        Type: 'Todos',
        Name: '',
        startDate: null,
        endDate: null
    })
    
    var sigPad = {}

    useLayoutEffect(() => {

        const id = props.match.params.id;

        if (id != 0) {
            getFunnel();            
        }
        else {
            let funnel = object;
            funnel.gtmUserId = getUser().id;
            setFunnel(funnel);
            getDataStructureTree();
            getDataStructureId();
            getUsersToUse();
        }

        getUserProfile();

        async function getFunnel() {
            setLoad(true)
            fetchDataView(id).then(response => {
                setFunnel(response.data);
                setLoad(false)
                let activities = [...response.data.funilActivities];
                for (var i = 0; i < activities.length; i++) {
                    if (activities[i].plilurl != null)
                        activities[i]['plilurlsaved'] = true;
                }
                activities=activities.sort(function (a, b) {
                    if (a.activity > b.activity) {
                      return 1;
                    }
                    if (a.activity < b.activity) {
                      return -1;
                    }
                    return 0;
                  })
                setFunnelActivity(activities)
                setOriginalArrayActivities(activities)
                setActivityQtd(activities.length)
                getDataStructureTree();
                if(response.data.gtmUserId == getUser().id)
                    setFunilEditor(true);
            }).catch(error => {
                setSnackBar({
                    ...snackBar,
                    isOpen: true,
                    message: "Erro na localização de dados do funil, tente novamente!",
                    type: 'error'
                })
            });
        }

        function getUsersToUse() {
            setLoad(true)
            return api.get('user/odata' + buildQuery({
                filter: {
                    factoryId: parseInt(getUserFactoryId()),
                },
                select: ['name', 'sap', 'id'],
                expand: {
                    companyRole: {
                        select: ['name']
                    },
                    Deparment: {
                        select: ['id', 'name']
                    }
                }
            }
            )).then(response => {
                setLoad(false)
                setUsersToUse(response.data.value);
            }).catch(error => {
                console.log(error);
                setSnackBar({
                    ...snackBar,
                    isOpen: true,
                    message: "Erro na localização da pessoas da fábrica, tente novamente!",
                    type: 'error'
                })
            });
        }

        function getDataStructureId() {
            setLoad(true)
            return api
                .get('/structure/odata?$expand=father($select=name)&$select=id,name,code,stepTpm, fatherId, typeId&$filter=factoryId+eq+' + getUserFactoryId())
                .then(response => {
                    setLoad(false)
                    setSetores(response.data.value)
                })
                .catch(error => {
                    console.log(error);
                    setSnackBar({
                        ...snackBar,
                        isOpen: true,
                        message: "Erro na localização da estruturas da fábrica, tente novamente!",
                        type: 'error'
                    })
                });
        }

        async function getDataStructureTree() {
            const structuresTree = await getStructureTree()
            setTreeData(parse(structuresTree.structures))
        }

        function getUserProfile()
        {            
            if(getUserAccessLevel() >= 9)
            {
                setGTMApprover(true);
                setGTAApprover(true);
                setSHEApprover(true);
                setFunilEditor(true);
            }
            if (getUserAccessLevel() >= 7) {
                setFunilEditor(true);
            }

            //request all factory approvers        
            getMyApprovalsAPI(getUser().id , getUserFactoryId()).then((res) => {
                if (res.status === 200 && res.data.value.length >= 1) {
                    res.data.value.forEach((item) => {
                        if((item.standardType == 'Funil' && item.standardClassification == 'GTM') 
                            || getUserAccessLevel() >= 9)
                            setGTMApprover(true);
                        if((item.standardType == 'Funil' && item.standardClassification == 'GTA') 
                        || getUserAccessLevel() >= 9)
                            setGTAApprover(true);
                        if((item.standardType == 'Funil' && item.standardClassification == 'SHE') 
                        || getUserAccessLevel() >= 9)
                            setSHEApprover(true);
                        if ((item.standardType == 'Funil' && item.standardClassification == 'ManutentorFunil') 
                        || isAdmin|| funnel.gtmUserId == getUser().id)
                            setFunilEditor(true);
                    })
                }
            }).catch(error => {
                setSnackBar({ ...snackBar, isOpen: true, message: 'Erro na coleta de dados de aprovadores, tente novamente!', type: 'error' })
                return false;
            });            
        }
    }, [])
    const updateImage = (step)=>{
        var image
        if(step >= 6){
            image = [{
                'url': '/media/funnel-image-2.png',
                'title': 'Funil'
            }]
        }else{
            image = [{
                'url': '/media/funnel-image.png',
                'title': 'Funil'
            }]
        }
        return image
    }
    /**
     * Update state snackbar for close
     */
    const handleCloseSnackbar = async () => {
        setTimeout(function() {
			setSnackBar({ ...snackBar, isOpen: false, message: '' })
		}, 3000);
    }

    const changeForm = (value, place) => {
        let data = JSON.parse(JSON.stringify(funnel));
        data[place] = value;
        setFunnel(data);
    }

    const changeFormActivity = (value, place, idxactivity, including = false) => {

        if (including) {
            let data = [...toIncludeArray]
            data[idxactivity][place] = value;
            setToIncludeArray(data);

            return;
        }

        let funnelActivityArray = [...funnelActivity];
        funnelActivityArray[idxactivity][place] = value;
        setFunnelActivity(funnelActivityArray);
    }

    const handleSelectStructure = (e, fieldToChange, isMachine = false) => {
        if (!isMachine && e) {
            const machineArray = recursiveGetMachinesByKey(e.id, treeData, []);
            setMachine(machineArray);
            SetStepTpm(e);
        }
       
        changeForm(e ? e.id : null, fieldToChange);
    }

    const newActivity = () => {

        let dataFiltered = [...toIncludeArray];
        dataFiltered.push(baseActivity);
        setToIncludeArray(dataFiltered);

    }

    const removeActivity = (idx, including) => {
        if (including) {
            setToIncludeArray([
                ...toIncludeArray.slice(0, idx),
                ...toIncludeArray.slice(idx + 1)
            ]);

            return;
        }
        var indexOriginalArray = originalArrayActivities.findIndex(o => o.id == funnelActivity[idx].id)
        setOriginalArrayActivities([
            ...originalArrayActivities.slice(0, indexOriginalArray),
            ...originalArrayActivities.slice(indexOriginalArray + 1)
        ]);

        setFunnelActivity([
            ...funnelActivity.slice(0, idx),
            ...funnelActivity.slice(idx + 1)
        ]);
    }

    const removeToIncludeActivity = (idx) => {
        setToIncludeArray([
            ...toIncludeArray.slice(0, idx),
            ...toIncludeArray.slice(idx + 1)
        ]);
    }

    const handleBadgeVisibility = (value, idx, place, including = false) => {
        if(value.length > 250){
            setSnackBar({ ...snackBar, isOpen: true, message: "Limite de caracteres excedido", type: 'error' })
        }else{
            if (including) {
                let data = [...toIncludeArray]
                data[idx][place] = value;
                setToIncludeArray(data);
    
                return;
            }
            let data = [...funnelActivity]
            data[idx][place] = value;
            setFunnelActivity(data);
        }
    }

    const initTransfer = () => {

        let errorMsg = ''

        funnel.gtmUserId = getUser().id;
        if (typeof funnel.gtaUserId === 'undefined' || funnel.gtaUserId === 0) {
            errorMsg = "Erro na criação do funil, faltando GTA.";
        }
        if (typeof funnel.structureId === 'undefined' || funnel.structureId === 0) {
            errorMsg = "Erro na criação do funil, faltando Estrutura.";
        }
        toIncludeArray.forEach((activity, idxActivity) => {
            if (activity.activity === '') {
                errorMsg = "Erro na criação do funil, faltando Nome da Atividade.";
            }
            if(activity.type === ''){
                errorMsg = "Erro na criação do funil, faltando Tipo da Atividade."
            }
            if(activity.classification === ''){
                errorMsg = "Erro na criação do funil, faltando Classificação da Atividade."
            }
        })

        if (errorMsg !== '') {
            console.log(errorMsg)
            setSnackBar({ ...snackBar, isOpen: true, message: errorMsg, type: 'error' })
        } else {
            setModal(true);
        }
    }

    function getBootstrapSwitchButton(activity, idxActivity, place, including = false, on = 'S', off = 'N') {
        if(place == 'question10'){
            on = 'OK'
            off = 'NOK'
        }
        if (place == 'question5' && activity.type == 'Troca')
            return (
                <LightTooltip title="Atividades de Troca podem responder sim e não para a pergunta 5 do funil.">
                    <Typography className="tittleFiltros" >OK</Typography>
                </LightTooltip>
                )

        if (typeof activity.id !== 'undefined'){
            if(place == "smallRepair"){
                return <BootstrapSwitchButton
                    checked={activity[place] == null ? false : activity[place]}
                    onlabel={on}
                    offlabel={off}
                    size="sm"
                    onChange={(checked) => handleBadgeVisibility(checked, idxActivity, place, including)}
                />;
            }else{
                return activity[place] ? on : off;
            }
        }else
            return <BootstrapSwitchButton
                checked={activity[place]}
                onlabel={on}
                offlabel={off}
                size="sm"
                onChange={(checked) => handleBadgeVisibility(checked, idxActivity, place, including)}
            />;
        
    }

    const handleValidateModal = (place, idxActivity) => {
        localStorage.setItem('placeApproval', place)
        localStorage.setItem('activity-idx', idxActivity);
        setModalValidate(true)
    }

    const handleDisapprovalModal = (idxActivity, place) => {
        localStorage.setItem('activity-idx', idxActivity);
        localStorage.setItem('responsibleForDisapproval', place);
        setModalDisapproval(true)
    }

    const checkIfCanValidate = (activity) => {
        if (activity.gtmApproval && activity.gtaApproval)
            return <Badge variant='success'>Transferência concluída</Badge>
        else
            return false;
    }

    const checkIfDisapproved = (activity) => {
        if (activity.managerGTMApproval == false || activity.managerGTAApproval == false ) {
            let responsavelReprova = '';
            if (activity.managerGTMApproval == false)
                responsavelReprova = 'Gestor GTM';
            if (activity.managerGTAApproval == false)
                responsavelReprova = 'Gestor GTA'
            if (activity.sheApproval == false)
                responsavelReprova = 'Gestor SHE'
            return (
                <OverlayTrigger
                    trigger="click"
                    key="top"
                    placement="top"
                    overlay={
                        <Popover id="top">
                            <Popover.Title as="h3">{'Motivo reprova'}
                            </Popover.Title>
                            <Popover.Content>
                                {activity.disapprovalObservation}
                            </Popover.Content>
                        </Popover>}>

                    <Button variant="warning" className="buttonDesc" >
                        <div >
                            <InfoOutlinedIcon /> Reprovado {responsavelReprova} </div>
                    </Button>
                </OverlayTrigger>)
        }
        else
            return false;
    }

    const checkIfUnderApproval = (activity) => {
        if ((typeof activity.id !== 'undefined') &&
            (activity.managerGTMApproval == null || activity.managerGTAApproval == null ))
            return <Badge variant='secondary'>Em fluxo aprovação</Badge>
        else
            return false;
    }

    const checkIfAlreadyApproved = (activity) => {
        if ((typeof activity.id !== 'undefined') &&
            (activity.managerGTMApproval === true && activity.managerGTAApproval === true))
            return true;
        else
            return false;
    }

    const checkIfCanTransfer = (activity) => {

        if (activity.question1 || activity.question2 || activity.question3 || activity.question4 ||
           ( activity.question5 && activity.type != 'Troca') || activity.question6 || activity.question7 || activity.question8 || activity.question9 || activity.question10)
            return <Badge variant='danger'>Instransferível</Badge>
        else
            return false
    }

    const checkIfPLILIsDefined = (activity) => {
        if (activity.piliurl === null)
            return <Badge variant='secondary'>PLIL em construção</Badge>
        else
            return false;
    }

    const validateTransfer = (activity, idxActivity, user, place) => {

        let stringLabel = 'Operador';
        if (place === 'gtmApproval')
            stringLabel = 'Manutentor';

        if ((getUser().id == funnel[user] || getUserAccessLevel() >= 9) && activity[place] === false) {
            return <Button variant='primary' onClick={() => handleValidateModal(place, idxActivity)}>
                Confirmar transferência {stringLabel}
            </Button>
        } else {
            if (activity[place]) {
                return <Badge variant='success'>Atividade transferida {stringLabel}</Badge>
            }
        }
    }


    function buildUITableRow(activity, idxActivity) {
        const transferability = checkIfCanTransfer(activity);
        if (transferability)
            return transferability;
        const validated = checkIfCanValidate(activity);
        if (validated) {
            switch (activeStep) {
                default:
                    return validated;
                case 3:
                    return (
                        <>
                            {validated}
                            &nbsp;       
                            { isAdmin ?
                                <>
                                    <input className='form-control' value={activity.plilurl}
                                        onChange={e => changeFormActivity(e.target.value, 'plilurl', idxActivity)} />
                                    <Button variant={activity.plilurlsaved !== true ? "primary" : "secondary"}
                                        onClick={(e) => savePlilUrl(idxActivity)}>
                                        {activity.plilurlsaved !== true ? 'Salvar link PLIL' : 'Substituir link PLIL atual'}
                                    </Button>
                                </>
                                :
                                <>
                                    { (activity.type === 'Inspeção' || activity.type === 'Lubrificação') &&
                                        <>
                                            Link PLIL: <a target='_blank' href={activity.plilurl} rel="noreferrer" > {activity.plilurl} </a>
                                        </>
                                    }
                                </>
                            }                            
                            
                        </>
                    )
                case 4:
                case 5:
                    return (
                        <>
                            {validated}
                            &nbsp;
                            { activity.dtpId &&
                                <a className='ml-3' target='_blank' href={'/dtp/' + activity.dtpId} rel="noreferrer">
                                    <Button variant="link">
                                        Ver DTP
                                </Button>
                                </a>
                            }
                            &nbsp;
                            {   activity.lppId &&
                                <a className='ml-3' target='_blank' href={'/lpp/' + activity.lppId} rel="noreferrer">
                                    <Button variant="outline-warning">
                                        Ver LPP
                                </Button>
                                </a>
                            }                            
                            < a className='ml-3' target='_blank' href={'/farol/' + funnel.id + '/' + activity.id} rel="noreferrer" >
                                <Button variant="warning">
                                    Farol
                                </Button>
                            </a >
                        </>
                    )
            }
        }

        const disapproved = checkIfDisapproved(activity);
        if (disapproved)
            return disapproved;
        if (activeStep > 2) {
            const underApproval = checkIfUnderApproval(activity);
            if (underApproval)
                return underApproval;
        }
        if (activeStep > 3) {
            const plilDefined = checkIfPLILIsDefined(activity);
            if (plilDefined)
                return plilDefined;
        }
        if (activeStep > 4) {
            if (activity.lppId === null && activity.dtpId === null) {
                return <Badge variant='dark'>Documento de conhecimento não criado</Badge>;
            }
        }

        switch (activeStep) {
            case 0: //perguntas
            default:
                break;

            case 2: //fluxo aprovacao
                return <>
                    {
                        activity.managerGTMApproval === null &&
                        <>
                            {
                                gtmApprover ?
                                    <>
                                        <Button variant="primary"
                                            onClick={(e) => handleApprovalButton(idxActivity, 'managerGTMApproval')}>
                                            Aprovação Gestor GTM
                                </Button>
                                &nbsp;
                                        <Button variant="danger"
                                            onClick={(e) => handleDisapprovalModal(idxActivity, 'managerGTMApproval')}>
                                            Reprovação Gestor GTM
                                </Button>
                                    </>
                                    :
                                    <Badge>Aguardando aprovação Gestor GTM</Badge>
                            }
                        </>
                    }
                    {
                        activity.managerGTMApproval &&
                        <Badge variant='info'>Gestor GTM Aprovou</Badge>
                    }
                    &nbsp;
                    {
                        activity.managerGTAApproval === null &&
                        <>
                            {
                                gtaApprover ?
                                    <>
                                        <Button variant="primary"
                                            onClick={(e) => handleApprovalButton(idxActivity, 'managerGTAApproval')}>
                                            Aprovação Gestor GTA
                                    </Button>
                                    &nbsp;
                                        <Button variant="danger"
                                            onClick={(e) => handleDisapprovalModal(idxActivity, 'managerGTAApproval')}>
                                            Reprovação Gestor GTA
                                    </Button>
                                    </>
                                    :
                                    <Badge>Aguardando aprovação Gestor GTA</Badge>
                            }
                        </>
                    }
                    {
                        activity.managerGTAApproval &&
                        <Badge variant='info'>Gestor GTA Aprovou</Badge>
                    }
                    
                </>
                break;

            case 3: //PLIL
                if (activity.type !== 'Inspeção' && activity.type !== 'Lubrificação')
                    return '';
                return <>
                    {
                        ((activity.gtmApproval !== true && activity.gtaApproval !== true) && (funilEditor)) || isAdmin ?
                            <>
                                <input className='form-control' value={activity.plilurl}
                                    onChange={e => changeFormActivity(e.target.value, 'plilurl', idxActivity)} />
                                <Button variant={activity.plilurlsaved !== true ? "primary" : "secondary"}
                                    onClick={(e) => savePlilUrl(idxActivity)}>
                                    {activity.plilurlsaved !== true ? 'Salvar link PLIL' : 'Substituir link PLIL atual'}
                                </Button>
                            </>
                            :
                            <>
                                { activity.plilurl != null &&
                                    <>
                                        Link PLIL 123: <a target='_blank' href={activity.plilurl} rel="noreferrer" >
                                            {activity.plilurl}
                                        </a>
                                    </>
                                }
                            </>
                    }
                </>
                break;

            case 4: // Docs                
                return <>
                    {
                        (activity.dtpTrained == true) ?
                            <Badge variant='primary'>Operadores treinados DTP</Badge>
                            :
                            <>
                                {
                                    (activity.gtmApproval !== true && activity.gtaApproval !== true) && (funilEditor) && activity.lppId === null &&
                                    <>
                                        <Button variant="outline-info" disabled={activity.gtmApproval}
                                            onClick={(e) => handleShowModalDocSelection(e, idxActivity, 'dtp')}>
                                            Linkar a uma DTP
                                        </Button>       
                                        &nbsp;
                                        { activity.dtpId != null &&                                                
                                            <Button variant="dark" disabled={activity.gtmApproval}
                                                onClick={(e) => handleDisconnect(e, idxActivity, 'dtp')}>
                                                    Desconectar DTP
                                            </Button>                                                
                                        }                                        
                                    </>
                                }
                            </>
                    }
                    {(activity.dtpId) &&
                        <a className='ml-3' target='_blank' href={'/dtp/' + activity.dtpId} rel="noreferrer">
                            <Button variant="link">
                                Ver DTP
                            </Button>
                        </a>
                    }
                    &nbsp;
                    {
                        (activity.lppTrained) == true ?
                            <Badge variant='primary'>Operadores treinados LPP</Badge>
                            :
                            <>
                                {
                                    (activity.gtmApproval !== true && activity.gtaApproval !== true) && (funilEditor) && activity.dtpId === null &&
                                    <>
                                        <Button variant="outline-info" disabled={activity.gtmApproval}
                                            onClick={(e) => handleShowModalDocSelection(e, idxActivity, 'lpp')}>
                                            Linkar a uma LPP
                                        </Button>
                                        &nbsp;
                                        { activity.lppId != null &&
                                            <Button variant="dark" disabled={activity.gtmApproval}
                                                onClick={(e) => handleDisconnect(e, idxActivity, 'lpp')}>
                                                Desconectar LPP
                                            </Button>
                                        }  
                                    </>
                                }
                            </>

                    }
                    {(activity.lppId) &&
                        <a className='ml-3' target='_blank' href={'/lpp/' + activity.lppId} rel="noreferrer">
                            <Button variant="outline-warning">
                                Ver LPP
                            </Button>
                        </a>
                    }
                </>
                break;

            case 5: //Treinamento 
                var returnValue = []
                if (activity.dtpId != null) {
                    if (activity.dtpTrained != null) {

                        if (activity.dtpTrained == false)
                            returnValue.push(<Badge variant='light'>Aguardando Farol</Badge>)
                        else
                            returnValue.push(<Badge variant='primary'>Operadores treinados DTP</Badge>)

                    }
                    else {
                        returnValue.push(<Badge variant='warning'>GTA precisa ser apontado no treinamento DTP</Badge>)
                    }
                    returnValue.push('   ');
                    returnValue.push(<a className='ml-3' target='_blank' href={'/dtp/' + activity.dtpId} rel="noreferrer">
                        <Button variant="link">
                            Ver DTP
                            </Button>
                    </a>);
                    returnValue.push(
                        < a className='ml-3' target='_blank' href={'/farol/' + funnel.id + '/' + activity.id} rel="noreferrer" >
                            <Button variant="warning">
                                Farol
                                </Button>
                        </a >)
                }
                returnValue.push('   ');
                if (activity.lppId != null) {
                    if (activity.lppTrained != null) {
                        if (activity.lppTrained == false)
                            returnValue.push(<Badge variant='light'>Aguardando Farol</Badge>)
                        else
                            returnValue.push(<Badge variant='primary'>Operadores treinados LPP</Badge>)                        
                    }
                    else {
                        returnValue.push(<Badge variant='warning'>GTA precisa ser apontado no treinamento LPP</Badge>)
                    }
                    returnValue.push(<a className='ml-3' target='_blank' href={'/lpp/' + activity.lppId} rel="noreferrer">
                        <Button variant="outline-warning">
                            Ver LPP
                            </Button>
                    </a>);
                    returnValue.push(
                        < a className='ml-3' target='_blank' href={'/farol/' + funnel.id + '/' + activity.id} rel="noreferrer" >
                            <Button variant="warning">
                                Farol
                                </Button>
                        </a >)
                }


                return <>
                    {returnValue}
                </>;

                break;

            case 6: //Aprovacao    
                if ((activity.lppId != null && activity.lppTrained == null) ||
                    (activity.dtpId != null && activity.dtpTrained == null))
                    return <Badge variant='warning'>GTA precisa ser apontado no treinamento</Badge>

                if ((activity.lppId != null && activity.lppTrained == false) ||
                    (activity.dtpId != null && activity.dtpTrained == false)) {
                    return <Badge variant='light'>Aguardando Farol</Badge>
                }

                return <>
                &nbsp;
                    {
                        activity.sheApproval === null &&
                        <>
                            {
                                sheApprover ?
                                    <>
                                        <Button variant="primary"
                                            onClick={(e) => handleApprovalButton(idxActivity, 'sheApproval')}>
                                            Aprovação Gestor SHE
                                    </Button>
                                    &nbsp;
                                        <Button variant="danger"
                                            onClick={(e) => handleDisapprovalModal(idxActivity, 'sheApproval')}>
                                            Reprovação Gestor SHE
                                    </Button>
                                    </>
                                    :
                                    <Badge>Aguardando aprovação Gestor SHE</Badge>
                            }
                        </>
                    }
                    {
                        activity.sheApproval &&
                        <Badge style={{marginRight: '2px'}} variant='info'>Gestor SHE Aprovou</Badge>
                    }
                    {activity.sheApproval && validateTransfer(activity, idxActivity, 'gtmUserId', 'gtmApproval')}
                                &nbsp;
                    {activity.sheApproval && validateTransfer(activity, idxActivity, 'gtaUserId', 'gtaApproval')}
                </>
                break;
        }
    }


    function getButtonStart() {
        if ((typeof funnel.id === 'undefined') && toIncludeArray.length > 0)
            return <Button variant='primary' onClick={() => initTransfer()}>Iniciar Transferência</Button>;
    }

    function getButtonBar() {
        if (typeof funnel.id !== 'undefined')
            return <>
                <Button variant='danger' disabled={activeStep === 0} onClick={() => backStep()}>Voltar</Button>
                {isSaving &&
                    <div className='w-100 text-center mx-auto'>
                        <CircularProgress />
                    </div>
                }
                {(!isSaving && activeStep !== 6) && <Button variant='primary' className='ml-3' onClick={() => nextStep()}>Avançar</Button>}
            </>;
    }

    async function nextStep() {
        let requestUpdate = false;
        
        switch (activeStep) {
            default:
            case 0:
                let needsToUpdateFunnel = false

                if (typeof funnel.id === 'undefined') {
                    needsToUpdateFunnel = true;
                }                
                
                let errorMsg = ''
                toIncludeArray.map((activity) => {                        
                    if (activity.activity === '') {
                        errorMsg = "Erro ao salvar funil, faltando Nome da Atividade.";
                    }
                })
                if (errorMsg !== '') {
                    console.log(snackBar)
                    setSnackBar({ ...snackBar, isOpen: true, message: errorMsg, type: 'error' })
                    return;
                }
                if (toIncludeArray.length > 0)
                    needsToUpdateFunnel = true;

                if (needsToUpdateFunnel)
                {
                    var mergedArray = _.cloneDeep(originalArrayActivities.concat(toIncludeArray));                 
                    requestUpdate = await UpdateFunnel(mergedArray);
                }
                
                if (requestUpdate) {
                    window.location.reload();
                }
                else {                    
                    setActiveStep(activeStep + 1);
                }
                break;
            case 1:
                var mergedArray = _.cloneDeep(originalArrayActivities.concat(toIncludeArray));         
        
                    requestUpdate = await UpdateFunnel(mergedArray);
                
                setActiveStep(activeStep + 1);
                break
            case 2:
                let oneApproval = false;

                funnelActivity.some((activity) => {
                    oneApproval = checkIfAlreadyApproved(activity);
                    if (oneApproval) {
                        return true;
                    }
                })

                if (oneApproval === false) {
                    setSnackBar({ ...snackBar, isOpen: true, message: 'Necessário ter uma atividade aprovada para avançar!', type: 'error' })
                } else {
                    setActiveStep(activeStep + 1);
                }
                break;
            case 3:
                setActiveStep(activeStep + 1);
                break;
            case 4:
                let hasDocument = false;

                funnelActivity.some((activity) => {
                    if (activity.lppId !== null || activity.dtpId !== null) {
                        hasDocument = true;
                        return true;
                    }

                    if (activity.gtmApproval && activity.gtaApproval) {
                        hasDocument = true;
                        return true;
                    }
                })

                if (!hasDocument) {
                    setSnackBar({ ...snackBar, isOpen: true, message: 'Necessário selecionar pelo menos um documento!', type: 'error' })
                } else {
                    setActiveStep(activeStep + 1);  
                    const requestTrainingData = await CheckTrainingCompletion();
                }
                break;
            case 5:
                let hasTrained = false;

                funnelActivity.some((activity) => {
                    if (activity.lppId != null && activity.dtpId != null) {
                        if (activity.lppTrained === true && activity.dtpTrained === true) {
                            hasTrained = true;
                            return true;
                        }
                    }
                    else {
                        if (activity.lppId != null) {
                            if (activity.lppTrained === true) {
                                hasTrained = true;
                                return true;
                            }
                        }
                        else {
                            if (activity.dtpId != null) {
                                if (activity.dtpTrained === true) {
                                    hasTrained = true;
                                    return true;
                                }
                            }
                        }
                    }

                    if (activity.gtmApproval && activity.gtaApproval) {
                        hasTrained = true;
                        return true;
                    }
                })

                if (!hasTrained) {
                    setSnackBar({ ...snackBar, isOpen: true, message: 'Necessário realizar pelo menos 1 treinamento!', type: 'error' })
                } else {
                    setActiveStep(activeStep + 1);
                }
                break;
        }
    }

    function savePlilUrl(idxActivity)
    {
        let funnelActivityArray = [...funnelActivity];
        funnelActivityArray[idxActivity]['plilurlsaved'] = true;
        setFunnelActivity(funnelActivityArray);
        UpdateFunnel();
    }

    async function UpdateFunnel(mergedArray = null) {
        let funilArray = [];

        if (mergedArray == null) {
            funilArray = originalArrayActivities;
        }
        else {
            funilArray = mergedArray;
        }       

        setIsSaving(true);

        let dataPost = _.cloneDeep(funnel);
        dataPost.funilActivities = funilArray;
        delete dataPost.gtaUser;
        delete dataPost.gtmUser;
        delete dataPost.structure;        
        for (var i = 0; i < dataPost.funilActivities.length; i++) {
            delete dataPost.funilActivities[i].managerGTAApprovalUser;
            delete dataPost.funilActivities[i].managerGTMApprovalUser;
            delete dataPost.funilActivities[i].sheApprovalUser;
        }        

        const result = updateFunnel(dataPost).then(() => {
            setIsSaving(false);
            return true;
        }).catch(error => {
            setSnackBar({ ...snackBar, isOpen: true, message: 'Erro ao salvar o funil, tente novamente!', type: 'error' })
            setIsSaving(false);
            return false;
        });
        
        return result;
    }

    async function CheckTrainingCompletion() {
        let needToUpdateFunnelForLPP = await trainingDataForEachStandard('lpp');
        let needToUpdateFunnelForDTP = await trainingDataForEachStandard('dtp');

        if (needToUpdateFunnelForLPP || needToUpdateFunnelForDTP) {
            await UpdateFunnel();
        }

        setSnackBar({ ...snackBar, isOpen: true, message: 'Treinamentos verificados.', type: 'success'})

        return true;
    }

    async function getTrainingData(standardId) {
        const result = await fetchTrainingSimple(standardId).then((res) => {
            if (res.status === 200 && res.data['_count'] >= 1) {
                if (res.data.value.length > 0)
                    return res.data.value;
                else
                    return null
            }
            else
                return null
        }).catch(error => {
            setSnackBar({ ...snackBar, isOpen: true, message: 'Erro na coleta de dados de treinamento, tente novamente!', type: 'error' })
            return null;
        });
        return result;
    }

    async function trainingDataForEachStandard(standardType = 'lpp') {
        let activities = [...funnelActivity];
        let needToUpdateFunnel = false;
        for (var i = 0; i < activities.length; i++) {
            if (activities[i][standardType + 'Id'] !== null && activities[i][standardType + 'Trained'] !== true) {               
                setActivityCheckingTraining(activities[i].id)
                setSnackBar({ ...snackBar, isOpen: true, message: 'Verificando dados de treinamento. Aguarde.', type: 'info' })
                
                const gtasTraining = await getTrainingData(activities[i][standardType + 'Id']);
                if (gtasTraining == null)
                    continue;
                let everyoneWasTrained = true;
                for (var j = 0; j < gtasTraining.length; j++) {
                    if (gtasTraining[j].status == false || gtasTraining[j].farolLvl20 == false ||
                        gtasTraining[j].farolLvl202 == false || gtasTraining[j].farolLvl70 == false) {
                        everyoneWasTrained = false;
                    }
                    if (gtasTraining[j].userId == funnel.gtaUserId) {
                        if (activities[i][standardType + 'Trained'] == null) {
                            needToUpdateFunnel = true;
                            activities[i][standardType + 'Trained'] = false;
                        }
                    }
                }
                if (everyoneWasTrained && activities[i][standardType + 'Trained'] !== null) {
                    activities[i][standardType + 'Trained'] = true;
                    needToUpdateFunnel = true;
                }
            }
        }
        setActivityCheckingTraining(0)
        if (needToUpdateFunnel) {
            await setFunnelActivity(activities);
        }
        return needToUpdateFunnel;
    }

    const backStep = () => {        
        setActiveStep(activeStep - 1);
    }

    function FormatadordeDatas (i) {
        var data = new Date(i);
        if (data === "Invalid Date") {
            return null
        }
        return data.toLocaleDateString();
    }

    function getNodeAutoComplete(dataToUse, fieldToChange, funnelData) {
        if (typeof funnel.id === 'undefined')
            return <Autocomplete
                id="combo-box-demo-gta"
                options={dataToUse}
                getOptionLabel={(option) => option.name + (option.father ? (' (' + option.father.name + ')') : '') +
                    (option.sap ? (' (SAP: ' + option.sap + ')') : '')}
                style={{ width: '100%' }}
                className='form-control'
                onChange={(event, newValue) => {
                    if (fieldToChange == 'structureId')
                        handleSelectStructure(newValue, fieldToChange);
                    else
                        changeForm(newValue.id, fieldToChange);
                }}
                renderInput={(params) => <TextField {...params} label="" />}
            />;
        else {            
            SetStepTpm(funnel[funnelData]) 
        }

        return <div className='card p-3'>{funnel[funnelData].name + (funnel[funnelData].sap ? " (SAP: " + funnel[funnelData].sap + ")" : '')}</div>
    }

    function SetStepTpm(structure) {
        if (structure?.typeId == 6) {//linha
            step = structure.stepTpm;
            return;
        }

        const lineAscendent = recursiveGetLineParentByKey(structure.fatherId, treeData);
        if (lineAscendent != null)
            step = lineAscendent.stepTpm;
        else
            step = structure.stepTpm
    }

    function getUsers(fieldToChange, funnelData, forceShowSelect = false) {
        if (typeof funnel.id === 'undefined' || forceShowSelect)
            return (
                <>
                <SelectAsyncPaginateUsers
                onChangeCallback={(option) => {
                    changeForm(option.id, fieldToChange);
                }}/>
                { forceShowSelect &&
                    <Button variant={"primary"}
                        onClick={(e) => UpdateFunnel()}>
                        {'Salvar novo ' + fieldToChange.substring(0,3).toUpperCase()}
                    </Button>
                }
                </>
            );
        else
            return <div className='card p-3'>{funnel[funnelData].name + (funnel[funnelData].sap ? " (SAP: " + funnel[funnelData].sap +")" : '')}</div>
    }

    const handleClose = (e, save = false) => {

        if (save) {
            let dataPost = JSON.parse(JSON.stringify(funnel));
            dataPost['funilActivities'] = toIncludeArray;
            dataPost.status = 1;

            createFunnel(dataPost).then(response => {
                setRedirect('/funnel/new/' + response.data.id);

                window.location.reload();
            }).catch(error => {
                setSnackBar({ ...snackBar, isOpen: true, message: 'Erro ao salvar o funil, tente novamente!', type:'error' })
                return false;
            });
        }
        setModal(false);
    };

    const handleShowModalDocSelection = (e, idxActivity, standardType) => {
        localStorage.setItem('activity-idx', idxActivity);
        setOptions(
            [
                {
                    "key": 1,
                    "value": standardType
                }
            ]);
        setModalDoc(true);
    }

    async function  handleDisconnect(e, idx, standardType){
        let funnelActivityArray = [...funnelActivity];
        funnelActivityArray[idx][standardType + 'Id'] = null;
        funnelActivityArray[idx][standardType + 'Trained'] = null;
        await setFunnelActivity(funnelActivityArray);
        const request = await UpdateFunnel();
    }

    function handleHideModalDoc()
    {
        setModalDoc(false);
        localStorage.removeItem('activity-idx')
    }

    async function handleCloseModalDoc(standardId, standardType, wasAStandardSelected = true) {

        if (!wasAStandardSelected)
            return;

        setModalDoc(false);
        
        let idx = localStorage.getItem('activity-idx');
        let funnelActivityArray = [...funnelActivity];
        funnelActivityArray[idx][standardType + 'Id'] = standardId;
        funnelActivityArray[idx][standardType + 'Trained'] = null;
        await setFunnelActivity(funnelActivityArray);
        const request = await UpdateFunnel();
        if (request === false) {
            funnelActivityArray[idx][standardType + 'Id'] = null;
            await setFunnelActivity(funnelActivityArray);
        }        

        localStorage.removeItem('activity-idx')
    }

    async function handleCloseValidate(e, save = false) {
        setModalValidate(false);

        if (save) {

            const canvas = sigPad.getTrimmedCanvas().toDataURL('image/png');
            const blob = dataURLtoBlob(canvas);
            const fd = new FormData();
            fd.append("canvasImage", blob, 'image.png');
            let link = ''
            await api.post('/standard/uploadFiles', fd, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                link = response.data.canvasImage;
            })
                .catch(function (error) {
                    setSnackBar({ ...snackBar, isOpen: false, message: 'Assinatura não pode ser salva. Tente novamente.', type:'error' })
                    console.log(error);
                });

            let idx = localStorage.getItem('activity-idx');
            let funnelActivityArray = [...funnelActivity];

            let place = localStorage.getItem('placeApproval');
            funnelActivityArray[idx]['signature'+place] = link;
            funnelActivityArray[idx][place] = true;
            await setFunnelActivity(funnelActivityArray);
            const request = await UpdateFunnel();
            if (request === false) {
                funnelActivityArray[idx][place] = false;
                await setFunnelActivity(funnelActivityArray);
            }

        }

        localStorage.removeItem('activity-idx')
        localStorage.removeItem('placeApproval')
    }

    async function handleCloseDisapproval(e, save = false) {
        setModalDisapproval(false);

        if (save) {
            let idx = localStorage.getItem('activity-idx');
            let funnelActivityArray = [...funnelActivity];
            funnelActivityArray[idx]['disapprovalObservation'] = funnel['disapprovalObservation'];
            funnelActivityArray[idx][localStorage.getItem('responsibleForDisapproval')] = false;
            funnelActivityArray[idx][localStorage.getItem('responsibleForDisapproval')+'UserId'] = getUser().id;
            await setFunnelActivity(funnelActivityArray);
            const request = await UpdateFunnel();
            if (request === false) {
                funnelActivityArray[idx]['disapprovalObservation'] = null;
                funnelActivityArray[idx][localStorage.getItem('responsibleForDisapproval')] = null;
                funnelActivityArray[idx][localStorage.getItem('responsibleForDisapproval') + 'UserId'] = null;
                setFunnelActivity(funnelActivityArray);
            }
        }

        delete funnel['disapprovalObservation'];
        localStorage.removeItem('responsibleForDisapproval');
        localStorage.removeItem('activity-idx');
    }

    async function handleApprovalButton(idx, approver) {
        let funnelActivityArray = [...funnelActivity];
        funnelActivityArray[idx][approver] = true;
        funnelActivityArray[idx][approver+'UserId'] = getUser().id;
        await setFunnelActivity(funnelActivityArray);
        const request = await UpdateFunnel();
        if (request === false) {
            funnelActivityArray[idx][approver] = false;
            funnelActivityArray[idx][approver + 'UserId'] = null;
            setFunnelActivity(funnelActivityArray);
        }
    }

    function getNameCurrentStructure() {
        let currentStructure = '';
        if (funnel.StructureId && setores.length > 0) {
            let currentStructureObject = _.first(setores.filter((item) => {
                return item.id === funnel.StructureId
            }));
            if (currentStructureObject)
                currentStructure = `(Atual: ${currentStructureObject.name})`;
        }
        return currentStructure
    }

    useEffect(() => {

        let filtroAtual = originalArrayActivities;

        if (filterState['Name'] !== '') {
            filtroAtual = filtroAtual.filter(function (atividade) {
                if (!atividade?.activity.toLowerCase().includes(filterState['Name'].toLowerCase()))
                    return false;
                return true;
            });
        }

        if (filterState['Type'] !== 'Todos') {
            filtroAtual = filtroAtual.filter(function (atividade) {
                if (atividade?.type === filterState['Type'])
                    return true;
                return false;
            });
        }

        if (filterState['startDate'] !== null || filterState['endDate'] !== null) {
            if(filterState['endDate'] === null){
                filtroAtual = filtroAtual.filter(function (atividade) {
                    if (atividade?.createdAt >= filterState['startDate'])
                        return true;
                    return false;
                });
            }else if(filterState['startDate'] === null){
                filtroAtual = filtroAtual.filter(function (atividade) {
                    if (atividade?.createdAt <= filterState['endDate'])
                        return true;
                    return false;
                });
            }else{
                filtroAtual = filtroAtual.filter(function (atividade) {
                    if ( atividade?.createdAt >= filterState['startDate'] && atividade?.createdAt <= filterState['endDate'])
                        return true;
                    return false;
                });
            }
        }
        setFunnelActivity(filtroAtual);
    },[filterState, originalArrayActivities]);

    function handleFilter(e, typeFilter){
        setFiltersState((prevState) => {
            return {
                ...prevState,
                [typeFilter]: e
            }
        })
    }

    function handleFilterDate(e, typeFilter){
        let time, stringDate;
        if(e){
            stringDate = e.getFullYear() + '-'
             + ('0' + (e.getMonth()+1)).slice(-2) + '-'
             + ('0' + e.getDate()).slice(-2);
        }
        if(typeFilter === 'endDate'){
            time = e ? `${stringDate}T23:59:00.000` : e;
        }else{
            time = e ? `${stringDate}T00:00:00.000` : e;
        }
        setFiltersState((prevState) => {
            return {
                ...prevState,
                [typeFilter]: (time)
            }
        })
    }

    const getStepName = () => {
        switch (activeStep) {
            case 1:
            default:
                return '3- Fluxo de aprovação';
            case 3:
                return '4- PLIL';
            case 4:
                return '5- Documentos de transferência de conhecimento';
            case 5:
                return '6- Transferência de conhecimento (treinamentos teóricos)';
            case 6:
                return '7- Confirmação';
        }
    }

    const getBadgeOrDeleteButton = (activity, idxActivity, including = false) => {
        const transferability = checkIfCanTransfer(activity);
        if (transferability)
            return transferability;
        const validated = checkIfCanValidate(activity);
        if (validated)
            return validated;
        const disapproved = checkIfDisapproved(activity)
        if (disapproved)
            return disapproved;

        if (activity.managerGTAApproval == null &&
            activity.managerGTMApproval == null &&
            activity.sheApproval == null) {
            return (
                <button className='btn-sm btn-danger fas fa-trash p-3'
                    onClick={() => removeActivity(idxActivity, including)} />)
        }            

        const checkUnderApproval = checkIfUnderApproval(activity)
        if (checkUnderApproval)
            return checkUnderApproval;
        
        return '';
    }

    const getClassificationOptions = (activity, idxActivity, including) => {

        return (
            <FormControl>
                <Select
                    value={activity['classification']}
                    onChange={(e) => handleChangeClassification(e, idxActivity, including)}
                    input={<Input name="standardType" id="standardType-label-placeholder" />}
                    displayEmpty
                    name="standardType"
                    className="w-85px"
                >
                    {(activity['type'] == 'Inspeção' || activity['type'] == 'Reparo') && <MenuItem value={'Elétrica'}>Elétrica</MenuItem>}
                    {(activity['type'] == 'Inspeção' || activity['type'] == 'Reparo') && <MenuItem value={'Eletrônica'}>Eletrônica</MenuItem>}
                    {(activity['type'] == 'Inspeção' || activity['type'] == 'Reparo') && <MenuItem value={'Fixação'}>Fixação</MenuItem>}
                    {(activity['type'] == 'Inspeção' || activity['type'] == 'Reparo') && <MenuItem value={'Hidráulica'}>Hidráulica</MenuItem>}
                    {(activity['type'] == 'Inspeção') && <MenuItem value={'Instrumentação'}>Instrumentação</MenuItem>}                    
                    {(activity['type'] == 'Inspeção' || activity['type'] == 'Reparo') && <MenuItem value={'Outras'}>Outras</MenuItem>}
                    {(activity['type'] == 'Inspeção' || activity['type'] == 'Reparo') && <MenuItem value={'Pneumática'}>Pneumática</MenuItem>}
                    {(activity['type'] == 'Inspeção' || activity['type'] == 'Reparo') && <MenuItem value={'Transmissão'}>Transmissão</MenuItem>}
                    {(activity['type'] == 'Troca') && <MenuItem value={'Troca'}>Troca</MenuItem>}
                    {(activity['type'] == 'Lubrificação') && <MenuItem value={'Lubrificação'}>Lubrificação</MenuItem>}
                    {(activity['type'] == 'Lubrificação') && <MenuItem value={'Inspeção'}>Inspeção</MenuItem>}
                    {(activity['type'] == 'Lubrificação') && <MenuItem value={'Reparo'}>Reparo</MenuItem>}
                    {(activity['type'] == 'Reparo') && <MenuItem value={'Troca de Formato'}>Troca de Formato</MenuItem>}
                </Select>
            </FormControl>)
    }

    const getTypeOptions = (activity, idxActivity, including = false) => {
        return (
            <FormControl>
                <Select
                    value={activity['type']}
                    onChange={(e) => handleChangeType(e, idxActivity, including)}
                    input={<Input name="standardType" id="standardType-label-placeholder" />}
                    displayEmpty
                    name="standardType"
                    className="w-85px"
                >
                    <MenuItem value={'Inspeção'}>Inspeção</MenuItem>
                    <MenuItem value={'Lubrificação'}>Lubrificação</MenuItem>                    
                    <MenuItem value={'Reparo'}>Reparo</MenuItem>
                    <MenuItem value={'Troca'}>Troca</MenuItem>                    
                </Select>
            </FormControl>)
    }

    function handleChangeClassification(event, idxActivity, including) {
        changeFormActivity(event.target.value, 'classification', idxActivity, including);
    }

    function handleChangeType(event, idxActivity, including) {
        changeFormActivity(event.target.value, 'type', idxActivity, including);
        switch (event.target.value) {
            default:
            case 'Inspeção':
            case 'Reparo':
                changeFormActivity('Outras', 'classification', idxActivity, including);
                break;
            case 'Lubrificação':
                changeFormActivity('Lubrificação', 'classification', idxActivity, including);
                break;
            case 'Troca':
                changeFormActivity('Troca', 'classification', idxActivity, including);
                break;
        }
    }
    const openModal = (activity)=>{
        setCopy_activity(activity)
        setName(activity.activity)
        setModalEditActivityName(true)
    }
    function RenderStep0Array(actArray, including) {
        return( 
        <>
        {
                actArray.map((activity, idxActivity) => (
                <>
                    <tr key={idxActivity}>
                        <td>
                            {(typeof activity.id !== 'undefined') && activity.activity}
                            {(typeof activity.id === 'undefined') &&
                                <input className='form-control' value={activity.activity} maxlength="251"
                                    onChange={(e) => handleBadgeVisibility(e.target.value, idxActivity, 'activity', including)} />
                            }
                        </td>
                        { ((getUser().id === funnel.gtmUserId) || (getUserAccessLevel() >= 7)) &&
                            <td>
                                <Button onClick={(e) => openModal(activity)}>Editar nome</Button>
                            </td>
                        }
                        <td>
                            {(typeof activity.id !== 'undefined') && activity.type}
                            {(typeof activity.id === 'undefined') &&
                                getTypeOptions(activity, idxActivity, including)
                            }
                        </td>
                        <td>
                            {(typeof activity.id !== 'undefined') && activity.classification}
                            {(typeof activity.id === 'undefined') &&
                                getClassificationOptions(activity, idxActivity, including)
                            }
                        </td>
                        <td>
                            {FormatadordeDatas(activity?.createdAt)}
                        </td>
                        <td>
                                {getBootstrapSwitchButton(activity, idxActivity, 'question1', including)}
                        </td>
                        <td>
                                {getBootstrapSwitchButton(activity, idxActivity, 'question2', including)}
                        </td>
                        <td>
                                {getBootstrapSwitchButton(activity, idxActivity, 'question3', including)}
                        </td>
                        <td>
                                {getBootstrapSwitchButton(activity, idxActivity, 'question4', including)}
                        </td>
                        <td>
                                {getBootstrapSwitchButton(activity, idxActivity, 'question5', including)}
                        </td>
                        <td>
                                {getBootstrapSwitchButton(activity, idxActivity, 'question6', including)}
                        </td>
                        <td>
                                {getBootstrapSwitchButton(activity, idxActivity, 'question7', including)}
                        </td>
                        {step >= 6 ?
                            <>
                                <td>
                                    {getBootstrapSwitchButton(activity, idxActivity, 'question8', including)}
                                </td>
                                <td>
                                    {getBootstrapSwitchButton(activity, idxActivity, 'question9', including)}
                                </td>
                                <td>
                                    {getBootstrapSwitchButton(activity, idxActivity, 'question10', including)}
                                </td>
                            </>
                            :
                            null
                        }
                        <td>
                                {getBadgeOrDeleteButton(activity, idxActivity, including)}
                        </td>
                    </tr>
                </>
            ))
                }
            </>)
        
    }
    const handleChangeName = (e) =>{
        if(e.length > 250){
            setSnackBar({ ...snackBar, isOpen: true, message: 'O campo nome deve ter no maximo 250 caracteres', type:'error' })
            return
        }
        setName(e)
    }
    const handleClosemodalEditActivityName = () =>{
        setModalEditActivityName(false)
    }
    const handleSaveActivityName = () =>{
        setLoad(true)
        if(name == '' || name == null){
            setSnackBar({ ...snackBar, isOpen: true, message: 'O campo nome esta vazio ou é invalido', type:'error' })
            setLoad(false)
            return
        }
        let copy = [...originalArrayActivities]
        for(let i=0;i<copy.length;i++){
            if(copy[i].id === copy_activity.id){
                copy[i].activity = name
            }
        }
        UpdateFunnel(copy)
        setLoad(false)
        setModalEditActivityName(false)
    }
    function RenderSmallRepair(actArray, including){ 
        return( 
            <>
            {
                    actArray.map((activity, idxActivity) => (
                    <>
                        <tr key={idxActivity}>
                            <td>
                                {(typeof activity.id !== 'undefined') && activity.activity}
                                {(typeof activity.id === 'undefined') &&
                                    <input className='form-control' value={activity.activity}
                                        onChange={(e) => handleBadgeVisibility(e.target.value, idxActivity, 'activity', including)} />
                                }
                            </td>
                            <td>
                                {(typeof activity.id !== 'undefined') && activity.type}
                                {(typeof activity.id === 'undefined') &&
                                    getTypeOptions(activity, idxActivity, including)
                                }
                            </td>
                            <td>
                                {(typeof activity.id !== 'undefined') && activity.classification}
                                {(typeof activity.id === 'undefined') &&
                                    getClassificationOptions(activity, idxActivity, including)
                                }
                            </td>
                            <td>
                                {FormatadordeDatas(activity?.createdAt)}
                            </td>
                            <td>
                                {getBootstrapSwitchButton(activity, idxActivity, 'smallRepair', including)}
                            </td>
                        </tr>
                    </>
                ))
                    }
                </>)
    }

    const [fileImportFunilActivities, setfileImportFunilActivities] = useState({});
    const [showImporter, setShowImporter] = useState(false);
    const [loadingImporter, setLoadingImporter] = useState(false);

    function FormatForm() {
        const formData = new FormData();
        formData.append('file', fileImportFunilActivities);
        return (formData);
    }

    function ImportFunilActivities() {
        setLoadingImporter(true);
        let retorno = api.post(`/funil/ImportFunilActivities/${funnel.id ?? 0}`, FormatForm())
            .then((responseApi) => {
                const funilActivitiesList = responseApi.data;
                setToIncludeArray([...toIncludeArray, ...funilActivitiesList])
                setShowImporter(false);
                setfileImportFunilActivities({});
                setLoadingImporter(false);
            })
            .catch((err) => {
                console.log(err)
                setShowImporter(false);
                setSnackBar({
                    ...snackBar,
                    isOpen: true,
                    message: `${err}`,
                    type: 'error'
                })
                setfileImportFunilActivities({});
                setLoadingImporter(false);
            })
    }

    const handleChange = (event) => {
        setfileImportFunilActivities(event.target.files[0]);
    };

    return (
        <>
            {(redirect !== '') && <Redirect to={redirect} push={true} />}
            <div style={{ position: 'relative' }}>
                {
                    load ?
                        <Loading /> : null
                }

                <Snackbar
                    open={snackBar.isOpen}
                    anchorOrigin={{ vertical: snackBar.vertical, horizontal: snackBar.horizontal }}
                    key={snackBar.vertical + snackBar.horizontal}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                >
                    <AlertHelper onClose={handleCloseSnackbar} severity={ snackBar.type}>
                        {snackBar.message}
                    </AlertHelper>
                </Snackbar>

                <Modal show={modal} onHide={handleClose}>
                    <Modal.Body>
                        <div className='filters'>
                            <label className='w-100'>
                                Agora é necessário criar a aprovação das atividades por um responsável do GTM, GTA e SHE, 
                                seguida da criação de documentos de PLIL para cada transferência de Inspeção/Lubrificação do funil, 
                                seguida da criação de documentos de LPP e/ou DTP para avançar a transferência, e por fim é necessário
                                realizar o treinamento dos membros do GTA no documento de LPP e/ou DTP.
            </label>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={handleClose}>
                            Cancelar
          </Button>
                        <Button variant="primary" color="primary" onClick={(e) => handleClose(e, true)}>
                            OK
          </Button>
                    </Modal.Footer>
                </Modal>

                <ExternalStandardModal
                    structureId={funnel.structureId}
                    showModalDoc={showModalDoc}
                    standardOptions={options}
                    onHide={handleHideModalDoc}
                    onAccept={handleCloseModalDoc} />

                <Modal show={modalValidate} onHide={handleCloseValidate}>
                    <Modal.Body>
                        <div className='filters'>
                            <label className='w-100'>
                                Atesta que o operador está <b>capacitado</b> na atividade a ser transferida?
                            </label>
                        </div>
                        Assine abaixo    
                        <div
                            className="col-12 justify-content-center"
                            style={{
                                borderColor: 'black',
                                borderStyle: 'solid',
                                borderRadius: '10px',
                                margin: 'auto',
                                width: '280px',
                            }}
                        >
                            <SignatureCanvas
                                penColor="black"
                                canvasProps={{ height: 200, width: 250 }}
                                ref={(ref) => { sigPad = ref }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="contained" onClick={handleCloseValidate}>
                            Não
                        </Button>
                        <Button variant="primary" color="primary" onClick={(e) => handleCloseValidate(e, true)}>
                            Sim
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={modalDisapproval} onHide={handleCloseDisapproval}>
                    <Modal.Body>
                        <div className='filters'>
                            <label className='w-100'>
                                Insira uma justificativa para reprovação da atividade:
            </label>
                        </div>
                        <textarea type='textarea' style={{ height: "400px" }}
                            className='form-control'
                            name={'disapprovalObservation'} value={funnel['disapprovalObservation']}
                            onChange={e => changeForm(e.target.value, 'disapprovalObservation')}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={handleCloseDisapproval}>
                            Voltar
          </Button>
                        <Button variant="primary" color="primary" onClick={(e) => handleCloseDisapproval(e, true)}>
                            Confirmar reprovação
          </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={modalEditActivityName} onHide={handleClosemodalEditActivityName}>
                    <Modal.Body>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <div style={{marginBottom: '10px'}}>Digite o novo nome da atividade:</div>
                            <input value={name} type="text" onChange={(e) => handleChangeName(e.target.value)}/>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleClosemodalEditActivityName} variant="danger">Sair</Button>
                        <Button variant="primary" color="primary" onClick={handleSaveActivityName}>Salvar</Button>
                    </Modal.Footer>
                </Modal>

                <div>
                    <div className="container">

                       <div className="mt-4 row w-100">
                            <div className='col-12 mx-auto'>
                                <Typography variant="h4">
                                    Funil de Transferência de atividades - GTM para GTA
                                </Typography>
                            </div>
                        </div>

                        <div className='mt-2 row'>                            
                            <div className='col-4'>
                                <div key={'combo0'} className='mx-2 my-2 flex-grow-2'>
                                    <p className='m-0'>Setor/Linha <strong>{getNameCurrentStructure()}</strong></p>
                                    {getNodeAutoComplete(setores, 'structureId', 'structure')}
                                </div>
                            </div>
                            {
                                !isEmptyArray(machine)
                                    ? <div className='col-4'>
                                        <div key={'combo0'} className='mx-2 my-2 flex-grow-2'>
                                            <p className='m-0'>Máquina (ativo)</p>
                                            <Autocomplete
                                                id="combo-box-demo"
                                                options={machine}
                                                getOptionLabel={(option) => option.label}
                                                style={{ width: '100%' }}
                                                className='form-control'
                                                onChange={(event, newValue) => {
                                                    handleSelectStructure(newValue, 'structureId', true);
                                                }}
                                                renderInput={(params) => <TextField {...params} label="" />}
                                            />
                                        </div>
                                    </div>
                                    : ''

                            }
                        </div>

                        <div className='mt-2 row'>
                            <div className='col-12'>
                                <ExpansionPanel key={'step-responsible'} defaultExpanded={true} className="mt-4">
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header">
                                        <h3>Responsáveis</h3>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <div className='row w-100'>
                                            <div className='col-6'>
                                                <label className='w-100'>
                                                    Responsável pela abertura do funil
                                                    <div className='card p-3'>
                                                        {funnel.gtmUser != undefined ? funnel.gtmUser.name + " (SAP: " + (funnel.gtmUser.sap) + ")" : getUser().name + " (SAP: " +(getUser().sap)+")"}
                                                    </div>
                                                    {(isAdmin && typeof funnel.id !== 'undefined') &&
                                                        <>
                                                        Editar GTM (somente admin)
                                                        {getUsers('gtmUserId', 'gtmUser', true)}
                                                        </>
                                                    }
                                                </label>
                                            </div>
                                            <div className='col-6'>
                                                <label className='w-100'>
                                                    Membro do GTA
                                                    {getUsers('gtaUserId', 'gtaUser')}
                                                    {(isAdmin && typeof funnel.id !== 'undefined') && 
                                                        <>
                                                        Editar GTA (somente admin)
                                                        {getUsers('gtaUserId', 'gtaUser', true)}
                                                        </>
                                                    }
                                                </label>
                                            </div>
                                        </div>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                        </div>

                        <div className='mt-2 row'>
                            <GalleryLightbox images={updateImage(step)} style={{ width: 536, height: step >= 6 ? 900 : 644, margin: '0 auto' }} />
                        </div>

                        <div className="row w-100">
                            <div className='col-12 mx-auto'>
                                <Stepper activeStep={activeStep}>
                                    {steps.map((label, index) => {
                                        return (
                                            <Step key={label}>
                                                <StepLabel>{label}</StepLabel>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                            </div>
                        </div>
                        {
                            (typeof funnel.id !== 'undefined') &&
                            <div>
                            <ExpansionPanel defaultExpanded={false} className="mt-4">
                                    <ExpansionPanelSummary
                                        className="row"
                                        aria-controls="panel1a-content"
                                        id="panel1a-header">
                                        <h3>Filtros:</h3>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                    <Grid container>
                                        <Grid item sm={12} md={7}>
                                            <FormControl className="w-100">
                                            <TextField
                                                id="standard-author"
                                                label="Filtrar por Atividades"
                                                onChange={(e) => handleFilter(e.target.value, 'Name')}
                                            />  
                                            </FormControl>
                                        </Grid>
                                        <Grid item sm={12} md={7} className="mt-5">
                                        <FormControl className="w-100">
                                            <p>Filtrar por Tipo</p>
                                            <Select
                                                className="w-100"
                                                onChange={(e) => handleFilter(e.target.value,'Type')}
                                                value = {filterState.Type}
                                                placeholder="Todos"
                                            >
                                                <MenuItem id="1"  value={"Todos"}>
                                                    Todos
                                                </MenuItem>
                                                <MenuItem id="2"  value={"Inspeção"}>
                                                    Inspeção 
                                                </MenuItem>
                                                <MenuItem id="3"  value={"Lubrificação"}>
                                                    Lubrificação   
                                                </MenuItem>
                                                <MenuItem id="4"  value={"Reparo"}>
                                                    Reparo
                                                </MenuItem>
                                                <MenuItem id="5" value={"Troca"}>
                                                    Troca
                                                </MenuItem>
                                            </Select>                            
                                        </FormControl>
                                        </Grid>                                    
                                        <Grid item sm={12} md={7} className="my-5">
                                            <MuiPickersUtilsProvider locale={ptLocale} utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    clearable
                                                    className="w-45 mr-2"
                                                    label="Filtrar por data de"
                                                    format="dd/MM/yyyy"
                                                    value={filterState.startDate}
                                                    onChange={date => handleFilterDate(date, "startDate")}
                                                    InputAdornmentProps={{ position: "start" }}
                                                />
                                                <KeyboardDatePicker
                                                    clearable
                                                    className="w-45"
                                                    label="até"
                                                    format="dd/MM/yyyy"
                                                    value={filterState.endDate}
                                                    onChange={date => handleFilterDate(date, "endDate")}
                                                    InputAdornmentProps={{ position: "start" }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                    </Grid>
                                    </ExpansionPanelDetails>
                            </ExpansionPanel>
                            </div>
                        }

                        <div className='mt-2 row'>
                            <div className='col-12 card'>
                                {activeStep === 0 &&
                                    <table className='table table-striped'>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '40%' }}>Atividades</th>
                                                {getUserAccessLevel() > 7 && <th>Editar</th>}
                                                <th>Tipo</th>
                                                <th>Classificação</th>
                                                <th style={{ width: '10%' }}>Data de Criação</th>
                                                <th>1</th>
                                                <th>2</th>
                                                <th>3</th>
                                                <th>4</th>
                                                <th>5</th>
                                                <th>6</th>
                                                <th>7</th>                                                
                                                {step >= 6 ?
                                                    <>
                                                        <th>8</th>
                                                        <th>9</th>
                                                        <th>10</th>
                                                    </>
                                                    :
                                                    null
                                                }
                                            </tr>
                                        </thead>
                                    <tbody>
                                        {RenderStep0Array(funnelActivity, false)}
                                        {RenderStep0Array(toIncludeArray, true)}
                                        </tbody>
                                    </table>
                                }
                                {activeStep == 1 &&
                                    <table className='table table-striped'>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '40%' }}>Atividades</th>
                                            <th>Tipo</th>
                                            <th>Classificação</th>
                                            <th style={{ width: '10%' }}>Data de Criação</th>
                                            <th>É possível pequeno reparo?</th>
                                        </tr>
                                    </thead>
                                <tbody>
                                    {RenderSmallRepair(funnelActivity, false)}
                                    {RenderSmallRepair(toIncludeArray, true)}
                                    </tbody>
                                </table>
                                }
                                {activeStep >= 2 &&
                                    <table className='table table-striped'>
                                        <thead>
                                            <tr>
                                                <th>Atividades</th>
                                                <th>{getStepName()}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {funnelActivity.map((activity, idxActivity) => (
                                                <>
                                                    <tr key={idxActivity}>
                                                        <td>
                                                            {activityCheckingTraining == activity.id &&
                                                                <CircularProgress />
                                                            }
                                                            {activity.activity}
                                                        </td>
                                                        <td>
                                                            {buildUITableRow(activity, idxActivity)}
                                                        </td>
                                                    </tr>
                                                </>
                                            ))}
                                        </tbody>
                                    </table>
                                }

                                {activeStep === 0 && (funilEditor) &&
                                    <>
                                        <div className='justify-content-between row mt-5 mx-auto'>
                                            <Icon className='fa fa-plus-circle cursor-pointer' onClick={() => newActivity()} />
                                        </div>
                                        <Button className="my-5" variant="success" onClick={e => setShowImporter(!showImporter)}>
                                            Importar Atividades via Excel
                                        </Button>
                                    </>
                                }

                                {
                                    showImporter &&
                                    <>
                                        <Grid 
                                        style={{padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}
                                        item 
                                        >
                                            <div>
                                                <h4>Importar Atividades via Excel</h4>
                                            </div>
                                            {loadingImporter ?
                                                <Loading />
                                                :
                                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                                    <Button
                                                        href={TemplateFunilActivities}
                                                        style={{marginLeft: '0'}}
                                                    >
                                                        Template para importar Atividades
                                                    </Button>
                                                    <input type="file" style={{marginBottom: '10px', marginTop: '10px'}} 
                                                        onChange={handleChange}
                                                        />
                                                    <Button
                                                        onClick={() => ImportFunilActivities()}
                                                        variant="success"
                                                        style={{marginLeft: '0', justifyContent: 'center'}}
                                                        >
                                                        Importar
                                                    </Button>
                                                </div>
                                            }
                                        </Grid>
                                    </>
                                }
                            </div>
                        </div>

                        <div className='mt-4 row place-btn'>
                            <div className='col-12'>
                                <div className='text-center'>
                                    {getButtonStart()}
                                    {getButtonBar()}
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>
    );
}